import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";

export interface IMultiArrayCheckBoxProps {
    id: string;
    label?: string;
    value?: string[]; // Example: ["Email", "FirstName"]
    options?: { label: string; value: string }[];
    readOnly?: boolean;
    errorText?: string;
    direction?: "horizontal" | "vertical";
    required?: boolean;
    labelColor?: string;
    hasError?: boolean;
    onCompChange?(id: string, payload: string[]): void;
}

export const MultiArrayCheckBox = ({
    id,
    label,
    value = [],
    options = [],
    errorText,
    onCompChange,
    required = false,
    readOnly = false,
    labelColor,
    hasError = false,
    direction = "vertical",
}: IMultiArrayCheckBoxProps) => {
    const [selected, setSelected] = useState<string[]>(value);
    const [loadedOptions, setLoadedOptions] = useState(options);
    const [isInvalid, setInvalid] = useState(false);

    // useEffect(() => {
    //     if (!value) return;
    //     const incoming = [...value].sort().join(",");
    //     const current = [...selected].sort().join(",");
    //     if (incoming !== current) {
    //         setSelected(value);
    //     }
    // }, [value]);
    console.log("Initial data loaded", value);
    useEffect(() => {
        if (hasError) setInvalid(true);
    }, [hasError]);

    useEffect(() => {
        if (
            options.length !== loadedOptions.length ||
            options.some(
                (opt, i) =>
                    opt.value !== loadedOptions[i]?.value ||
                    opt.label !== loadedOptions[i]?.label
            )
        ) {
            setLoadedOptions(options);
        }
    }, [options, loadedOptions]);

    const handleToggle = (val: string) => {
        setSelected((prevSelected) => {
            const updated = prevSelected.includes(val)
                ? prevSelected.filter((item) => item !== val)
                : [...prevSelected, val];
            onCompChange?.(id, updated);
            return updated;
        });
    };

    const handleSelectAllToggle = () => {
        setSelected((prevSelected) => {
            const isAllSelected = prevSelected.length === loadedOptions.length;
            const updated = isAllSelected
                ? []
                : loadedOptions.map((opt) => opt.value);
            onCompChange?.(id, updated);
            return updated;
        });
    };

    const isSelectAllChecked =
        selected.length === loadedOptions.length && loadedOptions.length > 0;

    return (
        <Form.Group id={id} className="mb-4 formgroup">
            {label && (
                <Form.Label
                    style={{
                        color: labelColor || "black",
                        margin: "2% 0 0 2%",
                    }}
                >
                    {label} {required && <sup style={{ color: "red" }}>*</sup>}
                </Form.Label>
            )}

            <Form.Check
                className="formcheck form-check-select mb-2"
                type="checkbox"
                label={<strong>Select All</strong>}
                checked={isSelectAllChecked}
                onChange={handleSelectAllToggle}
                style={{ margin: "0 0 0 2%" }}
                disabled={readOnly}
            />

            {direction === "horizontal" ? (
                <div
                    style={{
                        display: "flex",
                        margin: "0 0 0 1%",
                        flexWrap: "wrap",
                    }}
                >
                    {loadedOptions.map((opt) => (
                        <Form.Check
                            key={opt.value}
                            className="formcheck form-check-select me-3"
                            type="checkbox"
                            label={opt.label}
                            value={opt.value}
                            checked={selected.includes(opt.value)}
                            onChange={() => handleToggle(opt.value)}
                            // isInvalid={isInvalid}
                            readOnly={readOnly}
                        />
                    ))}
                </div>
            ) : (
                <div className="row">
                    {loadedOptions.map((opt) => (
                        <div className="col-12" key={opt.value}>
                            <Form.Check
                                className="formcheck form-check-select"
                                type="checkbox"
                                label={opt.label}
                                value={opt.value}
                                checked={selected.includes(opt.value)}
                                onChange={() => handleToggle(opt.value)}
                                // isInvalid={isInvalid}
                                readOnly={readOnly}
                            />
                        </div>
                    ))}
                </div>
            )}

            {hasError && errorText && (
                <InputGroup>
                    <div
                        className="invalid-feedback d-block"
                        style={{ color: "red", padding: "0 0 1rem 1rem" }}
                    >
                        {errorText}
                    </div>
                </InputGroup>
            )}
        </Form.Group>
    );
};

MultiArrayCheckBox.defaultProps = {
    direction: "vertical",
    required: false,
    hasError: false,
    readOnly: false,
};
